<template>
  <footer class="bg-black text-center bottom-0 relative min-w-full">
    <div class="flex justify-around">
      <div class="flex flex-col tablet:flex-row auto-cols-min place-items-center pt-8">
        <div v-for="item in footerNavItems" :key="item.label" class="px-5 py-2.5 tablet:py-0">
          <a data-test="footer-nav-items" :href="item.url" class="no-underline text-white transition-colors duration-200 font-normal">{{ item.label }}</a>
        </div>
      </div>
    </div>
    <div class="flex justify-around m-8">
      <img src="https://m.cdn.sera.to/logos/logo.svg" alt="Serato" class="w-[180px]">
    </div>
    <div class="flex justify-around my-8">
      <div>
        <span v-for="item in socialIconItems" :key="item.icon">
          <a :href="item.url" target="_blank" rel="noopener noreferrer" class="mx-4">
            <component :is="item.icon" data-test="social-icons" class="fill-white inline no-underline hover:fill-highlight-blue transition-colors duration-200" />
          </a>
        </span>
      </div>
    </div>
    <div class="flex flex-col justify-around border-t border-grey-80 mx-4 pt-5 pb-[30px] text-grey-60 gap-1">
      <span class="m-0 text-xs">
        <a
          :href="DISCLAIMER_LINK_URL"
          class="text-grey-60 font-semibold leading-none tracking-normal underline transition-colors duration-100 ease-out hover:text-[#399CFF] hover:underline active:text-[#399CFF] active:underline focus:text-[#399CFF] focus:underline"
          style="font-family: 'HelveticaNeueW01-65Medi', 'Helvetica Now Var W05 Regular', Helvetica, Arial, sans-serif"
          data-test="disclaimer-link"
        >
          Do not sell or share my personal information
        </a>
      </span>
      <span class="m-0 text-xs" data-test="footer">© Serato 1999 - {{ currentYear }}. All rights reserved.</span>
    </div>
  </footer>
</template>

<script setup lang="ts">
import IconFacebook from '@serato/icons/Socials/IconFacebook.vue'
import IconYoutube from '@serato/icons/Socials/IconYoutube.vue'
import IconTwitch from '@serato/icons/Socials/IconTwitch.vue'
import IconInstagram from '@serato/icons/Socials/IconInstagram.vue'

const currentYear = new Date().getFullYear()
const SERATO_COM_URL = import.meta.env.VITE_APP_CLIENT_URI_SERATO_COM
const DISCLAIMER_LINK_URL = SERATO_COM_URL + '/legal/cookies#exercising-your-personal-information-rights'
interface NavItem {
  label: string;
  url: string;
}

const footerNavItems: NavItem[] = [
  { label: 'Support', url: 'https://support.serato.com/hc/en-us' },
  { label: 'Contact Us', url: SERATO_COM_URL + '/contact' },
  { label: 'About Us', url: SERATO_COM_URL + '/about' },
  { label: 'Careers', url: SERATO_COM_URL + '/careers' },
  { label: 'Resources', url: SERATO_COM_URL + '/resources' },
  { label: 'Legal', url: SERATO_COM_URL + '/legal' },
  { label: 'Privacy Policy', url: SERATO_COM_URL + '/legal/website-privacy-policy' }
]
interface SocialIcon {
     /* eslint-disable-next-line */
    icon: any,
    url: string
}

const socialIconItems: SocialIcon[] = [
  { icon: IconYoutube, url: 'https://www.youtube.com/user/seratohq' },
  { icon: IconInstagram, url: 'https://instagram.com/serato' },
  { icon: IconTwitch, url: 'https://www.twitch.tv/serato' },
  { icon: IconFacebook, url: 'https://www.facebook.com/serato' }
]
</script>
